"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tasks = exports.handleCrud = exports.handleList = exports.crudLens = exports.listLens = exports.initialState = void 0;
const monocle = require("monocle-ts");
const fp = require("fp-ts");
const listReducer = require("./list");
const crudReducer = require("./crud");
//#endregion
//#region INITIAL STATE
exports.initialState = {
    list: Object.assign({}, listReducer.initialState),
    crud: Object.assign({}, crudReducer.initialState)
};
//#endregion
//#region LENS
exports.listLens = monocle.Lens.fromProp('list');
exports.crudLens = monocle.Lens.fromProp('crud');
//#endregion
//#region REDUCER
const handleList = (action) => (state) => {
    const fn = listReducer.methods[action.type];
    if (fn) {
        return exports.listLens.modify((listState) => fn(listState, action))(state);
    }
    return state;
};
exports.handleList = handleList;
const handleCrud = (action) => (state) => {
    const fn = crudReducer.methods[action.type];
    if (fn) {
        return exports.crudLens.modify((crudState) => fn(crudState, action))(state);
    }
    return state;
};
exports.handleCrud = handleCrud;
//#endregion REDUCER
const tasks = (state = exports.initialState, action) => {
    return fp.function.compose((0, exports.handleList)(action), (0, exports.handleCrud)(action))(state);
};
exports.tasks = tasks;
//#endregion
//# sourceMappingURL=index.js.map